import { render, staticRenderFns } from "./ProductQuestions.vue?vue&type=template&id=24750290&"
import script from "./ProductQuestions.vue?vue&type=script&lang=js&"
export * from "./ProductQuestions.vue?vue&type=script&lang=js&"
import style0 from "./ProductQuestions.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProductQuestions.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports